import { InjectionToken } from '@angular/core';

export const TRANSLOCO_ORIGIN_URL = new InjectionToken<string>('TRANSLOCO_ORIGIN_URL');
